export default __webpack_public_path__ + "static/media/ic-camera-line.e0eabf6a.svg";